import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Tracking } from './tracking.service';

@Component({
  selector: 'fl-tracking',
  template: `
    <fl-page-view-tracking></fl-page-view-tracking>
    <fl-navigation-performance-tracking></fl-navigation-performance-tracking>
    <fl-error-tracking></fl-error-tracking>
    <fl-memory-leak-tracking></fl-memory-leak-tracking>
    <fl-synthetic-performance-tracking></fl-synthetic-performance-tracking>
    <fl-core-web-vitals-tracking></fl-core-web-vitals-tracking>
  `,
})
export class TrackingComponent implements OnInit {
  constructor(
    private tracking: Tracking,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.tracking.sendEventBacklog();
    }
  }
}
